/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read/Author"
  
}) {
let appointmentNoteSysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_note',
path: 'sys_created',
format: fromHelpers.formatDateTime,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentNoteAuthorUserPersonValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_note',
path: 'author_user.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="Author.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment_note.sys_created"
 format="helpers.js formatDateTime"
 text={appointmentNoteSysCreatedValueData}
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="by"
 color={dtColorsNeutral500}
 marginLeft={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment_note.author_user.person"
 format="/Data/format.js personName"
 text={appointmentNoteAuthorUserPersonValueData}
 color={dtColorsNeutral500}
 marginLeft={dtSpaceXxs}
 weight="bold"
/>
</div>
{children}
</React.Fragment>)
}